module.exports = __webpack_public_path__ + "static/img/center.5fd4f5f7.png";